import { WarningMessages } from 'constants/Warning.constants';

import { selectAllTranslations } from '@polyai/stream/store/reducers/translations/selectors';
import { GlobeIcon } from '@polyai/ui/components/atoms/Icons';
import { PopupMenuItem } from '@polyai/ui/components/molecules/PopupMenu';

import { TRANSLATION_PREFIX } from 'components/molecules/LexicalEditor/features/action/constants';
import type {
  ActionTagContentProps,
  ActionTypeInput,
  ActionTypeOutput,
} from 'components/molecules/LexicalEditor/features/action/types';
import { useActionsContext } from 'components/molecules/RichTextInputV2';
import { useAppSelector } from 'hooks/reduxHooks';

const TranslationTagContent = ({ remove }: ActionTagContentProps) => {
  return (
    <PopupMenuItem isDelete onClick={remove}>
      Remove
    </PopupMenuItem>
  );
};

export const useTranslationActionType = ({
  id,
}: ActionTypeInput): ActionTypeOutput => {
  const { isTranslationsEnabled } = useActionsContext();
  const translations = useAppSelector(selectAllTranslations);
  const translation = translations?.find(t => t.id === id);

  const warning = !translation
    ? WarningMessages.TRANSLATION_NOT_EXIST
    : undefined;

  return {
    Content: TranslationTagContent,
    Icon: GlobeIcon,
    name: translation?.translationKey ?? id,
    warning,
    prefix: TRANSLATION_PREFIX,
    isEnabled: isTranslationsEnabled,
    isLoading: false,
  };
};
